import { render, staticRenderFns } from "./productPlan.vue?vue&type=template&id=641dd64c&scoped=true"
import script from "./productPlan.vue?vue&type=script&lang=js"
export * from "./productPlan.vue?vue&type=script&lang=js"
import style0 from "./productPlan.vue?vue&type=style&index=0&id=641dd64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641dd64c",
  null
  
)

export default component.exports